<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    computed: {
        errors() {
            return this.$page.props.errors;
        },

        hasErrors() {
            return Object.keys(this.errors).length > 0;
        },
    },
});
</script>

<template>
    <div v-if="hasErrors" class="flex flex--v flex--valign-s flex--gap-15">
        <div class="text text--color-red text--size-18 text--semi-bold text--center">{{ $trans("auth.error") }}</div>

        <ul class="text text--accent-gray-b text--size-18 text--semi-bold text--center">
            <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
        </ul>
    </div>
</template>
